import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "height": "100%",
    "min-height": "50vh"
  }
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "search-container"
};
import { useCommonDialog } from '@/component-create/utils/hooks';
import { TREE_URL } from '@/api/system/department';
import { SearchForm } from '@/component-create/SearchForm';
import { Table } from '@/component-create/Table';
import { createFormItem } from '@/component-create/utils/create-form-item';
import { FORM_ITEM } from '@/components/form/enums';
import { createTableColumn } from '@/component-create/utils/create-table-column';
import { formatter as _formatter } from '@/utils/common';
import { USER_GENDER, USER_STATUS } from '@/constant/system/code';

import { ref, watch, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'UserInfoDialog',
  props: {
    title: {},
    defaultSelect: {}
  },
  emits: ['select'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var dialog = useCommonDialog('userDialog');
    var searchForm = null;
    var table = null;
    var searchFormRef = ref();
    var tableRef = ref();
    watch(function () {
      return props.defaultSelect;
    }, function () {
      if (table) {
        initSysSelect();
      }
    }, {
      immediate: true
    });
    function open() {
      dialog.open();
      if (!table || !searchForm) {
        nextTick(function () {
          renderSearchForm();
          renderTable();
        });
      } else {
        initSysSelect();
      }
    }
    function close() {
      dialog.close();
    }
    var SearchItems = [createFormItem('用户名', 'username', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('昵称', 'nickname', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '20'
    }), createFormItem('手机号码', 'phoneNumber', FORM_ITEM.INPUT, {
      clearable: true,
      maxlength: '11'
    }), createFormItem('性别', 'gender', FORM_ITEM.SELECT, {
      loader: 'USER_GENDER',
      allOption: true
    }), createFormItem('状态', 'status', FORM_ITEM.SELECT, {
      loader: 'USER_STATUS',
      allOption: true
    })];
    var column = [{
      type: 'selection'
    }, {
      label: '序号',
      type: 'index',
      width: '60'
    }, createTableColumn('用户名', 'username', '120'), createTableColumn('昵称', 'nickname', '120'), createTableColumn('手机号码', 'phoneNumber', '120', 'center'), createTableColumn('邮箱', 'email', '200', undefined, {
      showOverflowTooltip: true
    }), createTableColumn('性别', 'gender', '60', 'center', {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_GENDER, row.gender);
      }
    }), createTableColumn('状态', 'status', '60', 'center', {
      showOverflowTooltip: true,
      formatter: function formatter(row) {
        return _formatter(USER_STATUS, row.status);
      }
    }), createTableColumn('备注', 'remark', undefined, undefined, {
      showOverflowTooltip: true
    })];
    /**
     * 绘制搜索表单
     */
    function renderSearchForm() {
      searchForm = new SearchForm(searchFormRef.value, SearchItems, {
        labelWidth: '80px'
      });
      searchForm.onSearch = function (formData) {
        var _table;
        (_table = table) === null || _table === void 0 || _table.load(formData);
      };
    }
    /**
     * 绘制表格
     */
    function renderTable() {
      table = new Table(tableRef.value, column, [], {
        border: true,
        rowKey: 'id'
      }, 'system/user/page');
      table.onLoaded = function () {
        nextTick(function () {
          initSysSelect();
        });
      };
    }
    function initSysSelect() {
      if (props.defaultSelect) {
        var _table2;
        (_table2 = table) === null || _table2 === void 0 || _table2.setSelectRowKeys(props.defaultSelect);
      }
    }
    function confirm() {
      var _table3;
      var selectRows = ((_table3 = table) === null || _table3 === void 0 ? void 0 : _table3.getSelectRows()) || [];
      emits('select', selectRows);
      close();
    }
    function cancel() {
      close();
    }
    __expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_XSearchTree = _resolveComponent("XSearchTree");
      var _component_XFlexCtx = _resolveComponent("XFlexCtx");
      var _component_ElButton = _resolveComponent("ElButton");
      var _component_XCommonDialog = _resolveComponent("XCommonDialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_XCommonDialog, {
        ref: "userDialog",
        title: _ctx.title,
        width: "70%"
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", null, [_createVNode(_component_ElButton, {
            onClick: cancel
          }, {
            default: _withCtx(function () {
              return _cache[0] || (_cache[0] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_ElButton, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("确认")]);
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_XSearchTree, {
            url: _unref(TREE_URL),
            label: function label(item) {
              return "".concat(item.departmentName, "(").concat(item.departmentCode, ")");
            },
            value: "departmentCode",
            "el-tree-prop": {
              showCheckbox: true
            }
          }, null, 8, ["url", "label"])]), _createVNode(_component_XFlexCtx, {
            flex: 1
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
                ref_key: "searchFormRef",
                ref: searchFormRef
              }, null, 512), _createVNode(_component_XFlexCtx, {
                flex: 1
              }, {
                default: _withCtx(function () {
                  return [_createElementVNode("div", {
                    style: {
                      "height": "100%"
                    },
                    ref_key: "tableRef",
                    ref: tableRef
                  }, null, 512)];
                }),
                _: 1
              })])];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["title"])]);
    };
  }
});